import { 
  Menu,
  MenuButton, 
  Tooltip, 
  Image} from '@chakra-ui/react'
import {Stack } from "@chakra-ui/layout";
import {
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/menu";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/modal";

import { useToast } from "@chakra-ui/toast";
import ChatLoading from "../ChatLoading";
import { Spinner } from "@chakra-ui/spinner";
import { Input } from "@chakra-ui/input";
import { Button } from "@chakra-ui/button";
import { Box, Text } from "@chakra-ui/layout";
import { IconButton } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { BellIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { Avatar, AvatarBadge } from "@chakra-ui/avatar";
import React, { useState } from 'react'
import { ChatState } from '../../context/chatProvider';
import ProfileModal from './ProfileModal';
import {useHistory} from 'react-router-dom'
import { useDisclosure } from '@chakra-ui/react';
import { getSender } from "../../config/ChatLogistics";
import axios from 'axios';
import NotificationBadge  from "./NotificationBadge";
import UserListItem from "../userAvatar/UserListItem";
import EnvRoute from '../../middleware/envRoute';
import { refreshPage } from '../../config/ChatLogistics';
const ENDPOINT = EnvRoute('prod'); 

const SideDrawer = () => {
  const {
    setSelectedChat,
    user,
    notification,
    setNotification,
    chats,
    setChats,
  } = ChatState();

  const history = useHistory()
 const { isOpen, onOpen, onClose } = useDisclosure();
  const [ isOnline, setIsOnline ] = useState(user.isOnline)
 const [ search, setSearch ] = useState("")
 const [ searchResult, setSearchResult ] = useState([])
 const [ loading, setLoading ] = useState(false)
 const [ loadingChat, setLoadingChat ] = useState()


 const toast = useToast();

 const logOutHandler = () =>{
    setIsOnline(false)
   
    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      };
      axios.put(`${ENDPOINT}/api/user/update`, { user }, config);

    } catch (error) {
      toast({
        title: "Error updating user",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
     localStorage.removeItem("userInfo")
    history.push('/')
 }

const checkForSearch = () => {
 if (!search) {
      toast({
        title: "Please Enter something in search",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top-left",
      });
      return;
    }else{handleSearch(search)}

}

 const handleSearch = async (query) =>{
   setSearch(query)
    try {
        setLoading(true);

        const config = {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
      };

      const  data  = await axios.get(`${ENDPOINT}/api/user?search=${search}`, config);

      setLoading(false);
      setSearchResult([...data.data]);

    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Search Results",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
 }

 const accessChat = async (userId) => {
    console.log(userId);

    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      };
      const { data } = await axios.post(`${ENDPOINT}/api/chat`, { userId }, config);

      if (!chats.find((c) => c?._id === data?._id)) setChats([data, ...chats]);

      setSelectedChat(data);
      setLoadingChat(false);
      onClose();
    } catch (error) {
      toast({
        title: "Error fetching the chat",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  return (
    <>
      <Box
        display="flex"
        // direction="row"
        color='#000'
        justifyContent="space-evenly"
        alignItems='center'
        w="100%"
        maxH={'70px'}
        p="5px 10px 5px 10px"
        bg={'white'}
        borderWidth={"2px"}
        borderRadius={"5px 5px 0 0"}
        // boxShadow={"bxshd.mainComp"}
        backgroundColor={"#fff"}
        boxShadow={" 0px 0px 5px 0px rgba(134, 134, 134, 0.3)"}
        // backgroundColor={"#8686868f"}
        backgroundImage={"url('./assets/BodyBG_alpha.png')"}
        // backgroundSize={"cover"}
        >
          <Stack
          >
             <Menu >
              <MenuButton p={0}>
                <BellIcon fontSize={"xl"}  m={1} color={'#868686'}/>
                 <NotificationBadge
                count={notification?.length}
               
                // effect={Effect.SCALE}
              />
                 <MenuList pl={2}
                 backgroundColor={'#fff'}
                 >
              {!notification.length && "No New Messages"}
              {notification?.map((notif) => (
                <MenuItem
                  key={notif._id}
                  onClick={() => {
                    setSelectedChat(notif.chat);
                    setNotification(notification?.filter((n) => n !== notif));
                  }}
                >
                  {notif?.chat?.isGroupChat
                    ? `New Message in ${notif?.chat?.chatName}`
                    : `New Message from ${getSender(user, notif?.chat?.users)}`}
                </MenuItem>
              ))}
            </MenuList>
              </MenuButton>
            </Menu>

          {/* <Tooltip 
            label="Search users to chat" 
            hasArrow 
            placement='bottom-end'>
              <Button 
                h={'25px'}
                w={'fit-content'}
                onClick={onOpen}
                variant="ghost" 
                colorScheme='blue'
                border={'2px solid rgba(49, 214, 224, 0.7)'}
                borderRadius={'5px 0px 5px 0px'}
                // borderBottom={'none'}
                color='#000'>
                <i className="fas fa-search"> </i>
                <Text
                  display={{base:"none", md: "flex"}} 
                  px={1}
                  py={2}
                > Search User</Text>
              </Button>
          </Tooltip> */}

          
                    </Stack>

               <Tooltip
           label="click to refresh" 
            hasArrow 
            placement='bottom'
          >
        <Image
            // m = 'auto'
            display="flex"  
            m = {'auto'}
            // boxSize='30px'
            h = '50px'
            w = {'auto'}
            objectFit='cover'
            src='./assets/TinCan_Logo_03.png'
            alt='TinCan Logo'
            backgroundColor={"#fff"}
            p={"5px 8px"}
            borderRadius={"md"}
             border={'4px solid #868686'}
            onClick={()=>{refreshPage()}}
            cursor={'pointer'}
            boxShadow={"bxshd.inset_blk"}


          />
            </Tooltip>      
 
          <div>
           

            <Menu>
              <MenuButton
              as={Button}
              //  bg={'bgs.chtBtnSel'}
              //  bg={'white'}
              //  border={"brd.chtBtn"}
               borderRadius={'0 10px 0 10px'}
               border={'1px solid #868686'}
              //  border={'1px solid rgba(49, 214, 224, 0.7)'}
               borderLeft={'none'}
               borderTop={'none'}
              //  boxShadow={'bxshd.inset_lt_bl'}
              //  border={"brd.chtBtnAct"}
              rightIcon={<ChevronDownIcon/>}
              variant="ghost" 
                colorScheme='blue'
                color='#000'>
              
                <Avatar size='sm' cursor="pointer" name={user.preferredName} src={user.pic}>
                  <AvatarBadge 
                      h={'15px'}
                      w={'15px'}
                      border={'2px solid white'}
                      zIndex={1000}
                      borderRadius={'100%'}
                      backgroundColor={user.isOnline?'limegreen':'orange'}
                      />
                </Avatar>
              </MenuButton>

              <MenuList
              backgroundColor={'#fff'}
              borderRadius={'10px 0px 10px 0px'}
              >
                <ProfileModal user={user}>
                  <MenuItem >My Profile</MenuItem>
                </ProfileModal>

                <MenuDivider/>
                <MenuItem onClick={logOutHandler}>Logout</MenuItem>
              </MenuList>

            </Menu>
          </div>
      </Box>
      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />

        <DrawerContent

        //  backgroundImage={"url('./assets/BodyBG.png')"}
        backgroundSize={"cover"}
        borderRadius={"0px 10px 0 0"}
        boxShadow={'bxshd.inset_lt_bl'}
        backgroundColor={"bgs.bgsMain"}
        >
          <DrawerHeader
           bg={'white'}
            borderRadius={"10px 10px 0 0"}
            // background={"url('./assets/BodyBG.png')"}
            // backgroundSize={'cover'}
            boxShadow={'bxshd.inset_lt_bl'}
           borderBottomWidth="1px">
             <Box display={'flex'} w={'100%'} flexDirection={'row'} justifyContent={'space-evenly'}>

        <IconButton
              // display={{ base: "flex" }}
              // boxShadow={'bxshd.inset_lt_bl'}
              position={'absolute'}
              left={1}
              
              h={'30px'}
              w={'30px'}
              // m={1}
              background={"#FFFFFF91"}
               backdropFilter={"blur(4px)"}
                 border = {`1px solid #868686`}
                // _placeholder={{ opacity: 0.9, color: '#868686' }}
              color={"#868686"}
              borderRadius = "0px 10px  0px 10px"
              borderBottom={'none'}
              icon={<ArrowBackIcon />}
              onClick={() => onClose()}
            />
             Search Users
        </Box>
             </DrawerHeader>
          <DrawerBody>
            <Box display="flex" pb={2}>
              <Input
                placeholder="Search by name or email"
                mr={2}
                value={search}
                // onChange={(e) => setSearch(e.target.value)} 
                onChange={(e) => handleSearch(e.target.value)}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                
             />
              <Button 
              borderRadius = "0px 10px  0px 10px"
               background={"rgba(255, 255, 255, 0.3)"}
               backdropFilter={"blur(4px)"}
                 border = {`2px solid #868686`}
                boxShadow={'bxshd.inset_blk'}
                borderBottom={'None'}
              onClick={checkForSearch}>Go</Button>
            </Box>
            {loading ? (
              <ChatLoading />
            ) : (
              searchResult?.map((user) => (
                // user
                <UserListItem
                  key={user._id}
                  user={user}
                  handleFunction={() => accessChat(user._id)}
                  
                />
              ))
            )}
            {loadingChat && <Spinner ml="auto" display="flex" />}
          </DrawerBody>
        </DrawerContent>
        </Drawer>
    </>
  )
}

export default SideDrawer